import React, { useMemo, useState } from "react";
import {
  makeStyles,
  Checkbox,
  ListItem,
  ListItemText,
  Button,
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from "@material-ui/core";
import { Search, Block, Check } from "@material-ui/icons";
import { Map as ImmutableMap } from "immutable";
import { Pagination } from "@material-ui/lab";

const useStyles = makeStyles((theme) => ({
  nested: {
    padding: "2px 0 2px 16px",
    height: 32,
  },
  search: {
    "& input": {
      padding: 3,
    },
    "& > div": {
      padding: 3,
    },
    backgroundColor: "white",
    borderRadius: 5,
    width: "100%",
  },
  searchDark: {
    borderRadius: 5,
    marginBottom: 10,
    // border: "1px solid #666",
    width: "100%",
    display: "flex",
    "& input": {
      padding: 3,
      color: "white",
    },
    "& > div": {
      padding: 3,
      color: "white",
    },
    color: "white",
    backgroundColor: "#282828 !important",
  },
  listText: {
    fontSize: "0.85rem",
  },
  listErrorTextDark: {
    fontSize: "0.85rem",
    color: "red",
  },
  listErrorText: {
    fontSize: "0.85rem",
    color: "lightpink",
  },
  button: {
    color: "white",
    "&:disabled": {
      color: "black",
      backgroundColor: "lightGreen",
    },
  },
}));


function View({
  historical,
  onAll,
  onNone,
  setSearch,
  search,
  mySort,
  excluded,
  format,
  searchFilters,
  blocked,
  setBlocked,
  mode,
  onItemClick,
  legacyUI,
  viewType,
  rcId
}: {
  historical: ImmutableMap<string, any>;
  onAll: any;
  onNone: any;
  setSearch: any;
  search: string;
  mySort: any;
  excluded: Set<string>;
  format: any;
  searchFilters: string[];
  blocked: Set<string>;
  setBlocked: any;
  mode: string;
  onItemClick: any;
  legacyUI: boolean;
  viewType: string;
  rcId: string
}) {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const handlePageChange = (event: React.ChangeEvent<unknown>, page: number) => setCurrentPage(page)

  // Memoize filtered and sorted historical data
  const filtered = useMemo(() => historical
      .filter((user) =>
        searchFilters.some((filter) => {
          const value = user[filter];
          if (typeof value === "string") {
            return value.toLowerCase().includes(search.toLowerCase());
          }
          return Array.isArray(value) && value.includes(search);
        })
      )
      .valueSeq()
      .toArray()
      .sort(mySort), [historical, search, searchFilters, mySort]);

      const totalPages =  Math.ceil(filtered.length / itemsPerPage)

     
   return (
    <>
      <ListItem
        style={
          legacyUI
            ? {}
            : { display: "flex", justifyContent: "space-around", width: "100%" }
        }
      >
        {/* <Button
          style={{ color: "white" }}
          onClick={onAll}
          role="button"
          aria-label="Select All button"
        >
          Select All
        </Button> */}
        
      </ListItem>
      <ListItem>
        <TextField
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search />
              </InputAdornment>
            ),
          }}
          variant="outlined"
          classes={{
            root: mode === "dark" ? classes.searchDark : classes.search,
          }}
          onChange={(e) => setSearch(e.target.value)}
          value={search}
        />
      </ListItem>
      <ListItem
            button
            role="listitem"
            className={classes.nested}
            onClick={excluded.size > 0 ? onAll : onNone}
          >
            {
              excluded.size === filtered.length ? (
                <Checkbox
              color="default"
              checked={false}
              style={{ color: "white" }}
            />
              ) : (
                <Checkbox
              color="default"
              indeterminate={excluded.size > 0 }
              checked={excluded.size === 0 }
              style={{ color: "white" }}
            />
              )
            }
            <ListItemText
              classes={{ primary: classes.listText }}
            >
              {excluded.size > 0 ? "(Select All)" : "(Select None)"}
              </ListItemText>
          </ListItem>
       {filtered
        .sort((a, b) => (b.emergency ? 1 : 0) - (a.emergency ? 1 : 0))
        .sort((a, b) => (blocked.has(a.id) ? 1 : 0) - (blocked.has(b.id) ? 1 : 0))
        .slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        )
        .map((user) => (
          !blocked.has(user.id) ? 
          <ListItem
            button
            role="listitem"
            aria-label={`checkbox-${user.id}`}
            className={classes.nested}
            key={user.id}
            onClick={() => onItemClick(user)}
          >
            <Checkbox
              color="default"
              checked={!excluded.has(user.id)}
              style={{ color: "white" }}
            />
            <ListItemText
              primary={format(user)}
              classes={{ primary: classes.listText }}
            />
            <IconButton
              role="button"
              aria-label={`click to block-${user.id}`}
              classes={{ root: classes.button }}
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                setBlocked((oldBlocked: any) => {
                  const newBlocked = new Set(oldBlocked);
                  newBlocked.add(user.id);
                  return newBlocked;
                });
                if (!excluded.has(user.id)) onItemClick(user);
              }}
            >
              <Block />
            </IconButton>
          </ListItem> :
           <ListItem button className={classes.nested} key={user.id}>
           <Checkbox style={{ visibility: "hidden" }} />
           <ListItemText
             primary={
               <Typography
                 classes={{
                   root:
                     mode === "dark"
                       ? classes.listErrorTextDark
                       : classes.listErrorText,
                 }}
               >
                 {format(user)}
               </Typography>
             }
           />
           <IconButton
             role="button"
             aria-label={`click to show-${user.id}`}
             classes={{ root: classes.button }}
             size="small"
             onClick={(e) => {
               e.stopPropagation();
               setBlocked((oldBlocked: any) => {
                 const newBlocked = new Set(oldBlocked);
                 newBlocked.delete(user.id);
                 return newBlocked;
               });
             }}
           >
             <Check />
           </IconButton>
         </ListItem>
        ))}
        <div className={`sidebar-legacy-pagination-container ${mode === 'light' ? "light-pagination" : "dark-pagination"}`}>
        <Pagination count={totalPages} page={currentPage} size="small" color="primary" onChange={handlePageChange}/>
        </div>
    </>
  );
}

export default View;
